module.exports = __webpack_public_path__ + "static/media/company-img.9366c4ef.png";